import { render } from "./PlacesGallery.vue?vue&type=template&id=0e1379be&ts=true"
import script from "./PlacesGallery.vue?vue&type=script&lang=ts"
export * from "./PlacesGallery.vue?vue&type=script&lang=ts"

import "./PlacesGallery.vue?vue&type=style&index=0&id=0e1379be&lang=less"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__